<!--
 * @Description  : banner中上传图片
 * @Author       : wuxuebing
 * @Date         : 2025-03-24 17:53:52
 * @LastEditors  : git config user.sname
 * @LastEditTime : 2025-10-30 09:13:26
 * @FilePath     : \ngs_platform_manage_admin\src\components\upload\uploadPicture.vue
-->

<template>
	<div class="upload-layout">
		<template v-if="listType === 'picture-card'">
			<el-upload
				class="upload-demo"
				ref="upload"
				action=""
				:class="{ 'picture-demo': listType === 'picture-card' }"
				:list-type="listType"
				:disabled="isDisabled"
				:limit="maxNum"
				:on-exceed="onExceed"
				:on-change="onChange"
				:file-list="fileList"
				:multiple="multiple"
				:auto-upload="false"
			>
				<el-button slot="trigger" icon="el-icon-upload" v-if="mode !== 'view'" type="text">{{
					listType === 'text' ? '上传文件' : '上传图片'
				}}</el-button>
				<!-- 图片模式 -->
				<div slot="file" slot-scope="{ file }" class="picture-box">
					<img class="el-upload-list__item-thumbnail img-size" :src="file.filePath ? getImgUrl(file) : file.url" alt="" />
					<span class="el-upload-list__item-actions">
						<em class="mr5 el-icon-zoom-in cursor-pointer" title="查看" @click="doView(file)"></em>
						<em class="mr5 el-icon-download cursor-pointer" title="下载" v-if="file.id" @click="doDownload(file)"></em>
						<em class="el-icon-delete cursor-pointer" title="删除" v-if="mode !== 'view'" @click="doDelete(file)"></em>
					</span>
				</div>

				<div slot="tip" v-if="mode !== 'view'" class="el-upload__tip file-tip">
					<p class="text-overflow">请上传图片格式为 {{ acceptMsg }} 格式的文件</p>
					<!-- ，像素比：{{ width }}X{{ height }} -->
				</div>
				<!-- 没有文件时的文字说明 -->
			</el-upload>
		</template>

		<el-dialog :visible.sync="dialogObj.visible" title="图片预览" custom-class="preview-dialog">
			<img class="preview-img" :src="dialogObj.imgUrl" alt="" />
		</el-dialog>
	</div>
</template>

<script>
import { uploadToWeb, saveFile, getFiles, deleteFile } from 'api/modules/upload'
import { dateFormat } from 'utils/tools'

export default {
	name: 'upload_component',
	props: {
		// 当前查看模式
		mode: {
			type: String,
			default: 'add'
		},
		// 最大文件上传个数
		maxNum: {
			type: Number,
			default: 10
		},
		// 上传到那个数据库
		forDatabase: {
			type: String,
			default: ''
		},
		// 是否支持多选
		multiple: {
			type: Boolean,
			default: true
		},
		// 接收的文件类型
		acceptType: {
			type: Array,
			default: () => {
				return []
			}
		},
		// 回显业务表id
		aid: {
			type: String,
			default: ''
		},
		// 业务表名称 --- 由后台表名确定
		tableName: {
			type: String,
			default: 'bus_pro_contract'
		},
		// assortment
		assortment: {
			type: String,
			default: ''
		},
		// 附件模式 (picture-card 和 text 两种)
		listType: {
			type: String,
			default: 'text'
		},
		// 是否需要刷新页面
		needRefresh: {
			type: Boolean,
			default: true
		},
		disabled: {
			type: Boolean,
			default: false
		},
		isDisabled: {
			type: Boolean,
			default: false
		},

		// 像素宽
		width: {
			type: Number,
			default: 1920
		},
		// 像素高
		height: {
			type: Number,
			default: 300
		}
		// 上传地址
	},
	data() {
		return {
			fileList: [],
			addList: [],
			delList: [],
			isLoaded: false,
			// 文件预览对象
			dialogObj: {
				visible: false,
				imgUrl: ''
			},
			timer: null,
			nofiles: false
		}
	},
	mounted() {
		// 组件加载完毕后 渲染状态
		this.isLoaded = true
		this.aid ? this.getFiles() : ''
	},
	methods: {
		// 文件上传方法 --- 上传数据库
		fileUpload(uploadId, item, params) {
			// 在有上传数据的情况下
			let _aid = uploadId ? uploadId : this.aid

			if (this.timer) {
				clearTimeout(timer)
			}

			let dataParams = {
				path: params.path,
				md5: params.md5,
				size: params.size,
				aid: _aid,
				tableName: this.tableName,
				assortment: this.assortment,
				serverName: params.serverName,
				fileName: params.fileName
			}
			saveFile(dataParams)
				.then((res) => {
					// this.needRefresh ? this.doRefresh() : "";
					this.$emit('onUploadSuccess', { res, dataParams })
				})
				.catch((err) => {
					this.needRefresh ? this.doRefresh() : ''
				})
		},

		// 文件上传到服务器
		fileSend(aid) {
			let that = this
			if (this.addList.length > 0) {
				for (let item of this.addList) {
					let formData = new FormData()
					formData.append('file', item)
					formData.append('path', dateFormat('yyyy-mm-dd'))
					formData.append('output', 'json')

					let nameArr = item.name.split('.')
					let suffix = nameArr[nameArr.length - 1]
					let _name = `${this.$SnowFlake.nextId()}_${this.$generateRandomString()}.${suffix}`
					formData.append('filename', _name)

					uploadToWeb(formData)
						.then((res) => {
							res.data.fileName = item.name
							res.data.serverName = this.extractFilename(res.data.path)
							that.fileUpload(aid, item, res.data)
							// 回调
						})
						.catch((err) => {
							that.$message.error('附件上传服务器失败！')
							return false
						})
				}
			} else {
				this.needRefresh ? this.doRefresh() : ''
			}
		},
		// 截取字符串
		extractFilename(pathStr) {
			const lastSlashIndex = pathStr.lastIndexOf('/')
			// 处理没有斜杠的情况
			if (lastSlashIndex === -1) {
				return pathStr
			}
			return pathStr.substring(lastSlashIndex + 1)
		},

		// 数据回显
		getFiles() {
			getFiles({
				aid: this.aid,
				tableName: this.tableName,
				assortment: this.assortment
			})
				.then((res) => {
					this.fileList = res.data
				})
				.catch((err) => {
					this.fileList = []
				})
		},

		// 文件超出最大个数事件
		onExceed() {
			this.$message.warning('当前最多可上传' + this.maxNum + '个文件！')
		},

		// 查看文件
		doView(file) {
			// fileView(file.id)
			if (this.listType === 'picture-card') {
				this.dialogObj.imgUrl = file.filePath ? this.$uploadUrl + file.filePath : file.url
				this.dialogObj.visible = true
			} else {
				this.$message.info('该文件暂不支持预览!')
			}
		},

		// 下载文件
		doDownload(file) {
			// fileDownload(file.id)
			// this.$message.info('')
			if (file.id) {
				let _name = file && file.serverName ? file.serverName : file.fileName
				let _path = file.fileDirectory ? file.fileDirectory + _name : file.filePath
				this.$downloadFile(this.uploadUrl + _path, file.fileName)
			}
		},

		// 检测所选文件是否符合格式
		checkType(curType) {
			if (this.acceptType.length > 0) {
				if (this.acceptType.find((x) => x === curType)) {
					return true
				} else {
					this.$message.warning('文件格式不对，请重新选择!')
					return false
				}
			} else {
				return true
			}
		},

		// 获取图片地址
		getImgUrl(file) {
			let _name = file.serverName || file.fileName || ''
			return this.uploadUrl + file.fileDirectory + _name
		},

		// 文件列表变化事件
		async onChange(file, fileList) {
			let curType = file.name.substring(file.name.lastIndexOf('.') + 1)

			if (this.checkType(curType)) {
				// 如果不存在id 是添加情况
				// let isValidWidth = await this.checkWidth(file)

				// if (isValidWidth) {
				//   if (!file.id) {
				//     this.addList.push(file.raw);
				//   }
				// } else {
				//   this.needRefresh ? this.doDelete(file) : "";
				// }
				if (!file.id) {
					this.addList.push(file.raw)
				}
			} else {
				this.needRefresh ? this.doDelete(file) : ''
			}
		},

		// 检查宽高
		checkWidth(file) {
			return new Promise((resolve, reject) => {
				const img = new Image()
				let _URL = window.URL || window.webkitURL // 如果不需要使用 _URL，可以移除这行
				img.src = _URL.createObjectURL(file.raw) // 使用 file.raw 以确保正确获取文件对象

				img.onload = () => {
					const isValid = img.width === this.width && img.height === this.height //
					if (isValid) {
						resolve(true)
					} else {
						this.$message.error(`上传的图片尺寸必须为 ${this.width}*${this.height}!`)
						resolve(false)
					}
					_URL.revokeObjectURL(img.src) // 释放内存
				}
			})
		},

		// 删除文件
		doDelete(file) {
			let _index = this.$refs.upload.uploadFiles.findIndex((x) => x.uid === file.uid)
			// 如果有ID 弹窗提示
			if (file.id) {
				this.$confirm('确认要删除当前附件吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						deleteFile({ id: file.id })
							.then((res) => {
								// console.log(res)
								this.$message.success('删除成功!')
								this.fileList.splice(_index, 1)
							})
							.catch((err) => {})
					})
					.catch(() => {})
			} else {
				// 否则直接删除
				this.addList.splice(
					this.addList.findIndex((x) => x.uid === file.uid),
					1
				)
				this.$refs.upload.uploadFiles.splice(_index, 1)
			}
		},

		// 清除文件列表
		clearFiles() {
			this.$refs.upload.clearFiles()
			this.addList = []
			this.delList = []
		},

		// 不需要上传时直接刷新页面
		doRefresh() {
			// this.$message.success('保存成功！')
			if (this.timer) {
				clearTimeout(this.timer)
				this.timer = null
			} else {
				this.timer = setTimeout(() => {
					if (!this.$route.path.includes('redirect')) {
						this.$router.replace({
							path: '/redirect' + this.$route.path,
							query: this.$route.query
						})
					}
				}, 1000)
			}
		}
	},
	computed: {
		// 当前文件列表数量
		fileLength() {
			if (!this.isLoaded) {
				return 0
			}
			return this.$refs.upload.uploadFiles.length
		},

		// 支持的文件格式 文字
		acceptMsg() {
			return this.acceptType.length > 0 ? this.acceptType.join('、') : '所有格式文件'
		},

		// 上传接口地址
		uploadUrl() {
			return this.$uploadUrl
		}
	},
	watch: {
		aid(val) {
			if (val) {
				this.getFiles()
			}
		}
	}
}
</script>

<style lang="less">
.upload-layout {
	text-align: left;

	.file-item {
		display: flex;
		justify-content: space-between;
		padding: 0 5px;

		.item-left {
			width: 80%;
			padding: 0 5px;
			box-sizing: border-box;
		}

		.item-right {
			width: 20%;
			text-align: right;

			em {
				cursor: pointer;
			}
		}
	}

	.file-tip {
		font-size: 12px;
		margin-top: 0;
		height: 30px;
		line-height: 30px;
	}

	.el-upload {
		display: unset;
		text-align: left;
	}

	.upload-demo {
		color: #666;
		font-size: 14px;
	}

	.picture-demo {
		@color: #4a6ed6;

		.el-upload {
			display: inline-block;
			text-align: center;
			height: 80px;
			line-height: 80px;
			color: #4a6ed6;
		}

		.el-upload-list__item {
			width: 130px;
			width: 80px;
			height: 80px;
			border-color: #eee;
			vertical-align: middle;
		}

		.el-button--text {
			color: @color;
			display: inline-flex;
			justify-content: center;
			align-items: center;
		}

		.el-icon-upload {
			color: @color;
		}

		.img-size {
			width: 78px;
			height: 78px;
		}
	}

	.nothingfile {
		color: red;
	}
}
</style>
